/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddNeighboringReportPhotosDto } from '../models/AddNeighboringReportPhotosDto';
import type { CommentResponse } from '../models/CommentResponse';
import type { CreateCommentDto } from '../models/CreateCommentDto';
import type { CreateNeighboringReportDto } from '../models/CreateNeighboringReportDto';
import type { MessageResponse } from '../models/MessageResponse';
import type { NeighboringReportDetailResponse } from '../models/NeighboringReportDetailResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NeighboringReportsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a neighboring report
     * Creates a new neighboring report with optional photos. CLIENT users create citizen reports. MUNICIPALITY users create official reports (isOfficial=true) within their jurisdiction.
     * @returns NeighboringReportDetailResponse Report created successfully.
     * @throws ApiError
     */
    public neighboringReportsControllerCreate({
        requestBody,
    }: {
        requestBody: CreateNeighboringReportDto,
    }): CancelablePromise<NeighboringReportDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/neighboring-reports',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT or MUNICIPALITY role required. For MUNICIPALITY: location outside jurisdiction.`,
            },
        });
    }
    /**
     * List neighboring reports
     * Returns a paginated list of neighboring reports. Hidden reports (moderationStatus=HIDDEN) are excluded for non-admin users. When lat/lng are provided, filters by radius (from global setting NEIGHBORING_REPORTS_RADIUS_KM, default 3km) using PostGIS ST_DWithin and orders by distance.
     * @returns any List of neighboring reports.
     * @throws ApiError
     */
    public neighboringReportsControllerFindAll({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        type,
        lat,
        lng,
        userId,
        isOfficial,
        municipalityId,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by (ignored when lat/lng are provided)
         */
        sortBy?: string,
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by report type
         */
        type?: 'SUSPECT_INDIVIDUAL' | 'SUSPICIOUS_VEHICLE' | 'INTRUSION_ATTEMPT' | 'BURGLARY' | 'SPYING_AND_TRACKING' | 'OTHER',
        /**
         * Center latitude for radius search
         */
        lat?: number,
        /**
         * Center longitude for radius search
         */
        lng?: number,
        /**
         * Filter by user ID
         */
        userId?: string,
        /**
         * Filter by official status
         */
        isOfficial?: boolean,
        /**
         * Filter by municipality ID
         */
        municipalityId?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/neighboring-reports',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'type': type,
                'lat': lat,
                'lng': lng,
                'userId': userId,
                'isOfficial': isOfficial,
                'municipalityId': municipalityId,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * Get neighboring report detail
     * Returns a single neighboring report with photos and user details. The response includes `isOwner` to indicate whether the current authenticated user is the owner of the report (useful for showing delete/remove controls on the map).
     * @returns NeighboringReportDetailResponse Report found.
     * @throws ApiError
     */
    public neighboringReportsControllerFindOne({
        id,
    }: {
        /**
         * Report unique identifier
         */
        id: string,
    }): CancelablePromise<NeighboringReportDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/neighboring-reports/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Report not found.`,
            },
        });
    }
    /**
     * Delete a neighboring report
     * Deletes a neighboring report. CLIENT users can only delete their own reports. MUNICIPALITY users can delete any report within their jurisdiction.
     * @returns any Report deleted successfully.
     * @throws ApiError
     */
    public neighboringReportsControllerRemove({
        id,
    }: {
        /**
         * Report unique identifier
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/neighboring-reports/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Ownership or jurisdiction check failed.`,
                404: `Report not found.`,
            },
        });
    }
    /**
     * Like a neighboring report
     * Increments the likes count on a neighboring report.
     * @returns NeighboringReportDetailResponse Report liked successfully.
     * @throws ApiError
     */
    public neighboringReportsControllerToggleLike({
        id,
    }: {
        /**
         * Report unique identifier
         */
        id: string,
    }): CancelablePromise<NeighboringReportDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/neighboring-reports/{id}/like',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT or MUNICIPALITY role required.`,
                404: `Report not found.`,
            },
        });
    }
    /**
     * Dislike a neighboring report
     * Increments the dislikes count on a neighboring report.
     * @returns NeighboringReportDetailResponse Report disliked successfully.
     * @throws ApiError
     */
    public neighboringReportsControllerToggleDislike({
        id,
    }: {
        /**
         * Report unique identifier
         */
        id: string,
    }): CancelablePromise<NeighboringReportDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/neighboring-reports/{id}/dislike',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT or MUNICIPALITY role required.`,
                404: `Report not found.`,
            },
        });
    }
    /**
     * Add photos to a neighboring report
     * Allows the report owner to add additional photo URLs to an existing report.
     * @returns NeighboringReportDetailResponse Photos added successfully.
     * @throws ApiError
     */
    public neighboringReportsControllerAddPhotos({
        id,
        requestBody,
    }: {
        /**
         * Report unique identifier
         */
        id: string,
        requestBody: AddNeighboringReportPhotosDto,
    }): CancelablePromise<NeighboringReportDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/neighboring-reports/{id}/photos',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. You can only add photos to your own reports.`,
                404: `Report not found.`,
            },
        });
    }
    /**
     * Get comment count for a neighboring report
     * Returns the total number of comments on a specific neighboring report.
     * @returns any Comment count returned successfully.
     * @throws ApiError
     */
    public neighboringReportsControllerCountComments({
        reportId,
    }: {
        /**
         * Report unique identifier
         */
        reportId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/neighboring-reports/{reportId}/comments/count',
            path: {
                'reportId': reportId,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Report not found.`,
            },
        });
    }
    /**
     * List comments for a neighboring report
     * Returns a paginated list of comments for a specific neighboring report, sorted by creation date descending (most recent first).
     * @returns any List of comments.
     * @throws ApiError
     */
    public neighboringReportsControllerFindComments({
        reportId,
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
    }: {
        /**
         * Report unique identifier
         */
        reportId: string,
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by (alphanumeric, dots, and underscores only). Must be validated against allowed fields in the consuming service.
         */
        sortBy?: string,
        /**
         * Sort order
         */
        sortOrder?: 'asc' | 'desc',
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/neighboring-reports/{reportId}/comments',
            path: {
                'reportId': reportId,
            },
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
            },
            errors: {
                401: `Unauthorized.`,
                404: `Report not found.`,
            },
        });
    }
    /**
     * Add a comment to a neighboring report
     * Creates a new comment on a neighboring report. CLIENT users create normal comments. MUNICIPALITY users create official comments if the report is within their jurisdiction.
     * @returns CommentResponse Comment created successfully.
     * @throws ApiError
     */
    public neighboringReportsControllerCreateComment({
        reportId,
        requestBody,
    }: {
        /**
         * Report unique identifier
         */
        reportId: string,
        requestBody: CreateCommentDto,
    }): CancelablePromise<CommentResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/neighboring-reports/{reportId}/comments',
            path: {
                'reportId': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT or MUNICIPALITY role required. For MUNICIPALITY users, report must be within jurisdiction.`,
                404: `Report not found.`,
            },
        });
    }
    /**
     * Delete a comment
     * Deletes a comment. The comment owner, ADMIN users, or MUNICIPALITY users (if the report is within their jurisdiction) can delete it.
     * @returns MessageResponse Comment deleted successfully.
     * @throws ApiError
     */
    public neighboringReportsControllerDeleteComment({
        reportId,
        commentId,
    }: {
        /**
         * Report unique identifier
         */
        reportId: string,
        /**
         * Comment unique identifier
         */
        commentId: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/neighboring-reports/{reportId}/comments/{commentId}',
            path: {
                'reportId': reportId,
                'commentId': commentId,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. You can only delete your own comments, or must be ADMIN/MUNICIPALITY with jurisdiction.`,
                404: `Comment not found.`,
            },
        });
    }
}
